import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import ContactForm from "./forms/contact_form/ContactForm";

const Front = () => {
    return (
        <Router>
            <Routes>
                <Route
                    exact
                    path="/form/:slug"
                    element={<ContactForm />}
                ></Route>
            </Routes>
        </Router>
    );
};

export default Front;
